import axios from './axios';
import { handleApiError } from './apiErrorHandler';

export default {
    uploadFile: async (file) => {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await axios.post('/files/b2b/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            return { success: true, data: response.data };
        } catch (error) {
            return handleApiError(error);
        }
    },
};